export {default} from './GiftWithPurchase';

export const checkGiftWithPurchaseStatus = (gwpItem, cartItems) => {
  if (cartItems.length === 0) return;

  // Check if empty object
  if (Object.keys(gwpItem).length === 0) return;

  // Check if the GWP item is already in the cart
  const isInCart = cartItems.some((item) => item.product_id === gwpItem.product_id && item.properties?._gwp);

  const cartItemsWithoutGwp = cartItems.filter((item) => !item.properties?._gwp);

  // Check if the GWP item is the only one in cart
  if (cartItemsWithoutGwp.length === 0) {
    return {
      isInCart,
      isEligible: false,
    };
  }

  // Check if the minimum spend condition is met
  const minimumSpend = gwpItem.minimum_spend ?? 0;
  const includedProducts = gwpItem.include_products ?? [];
  const excludedProducts = gwpItem.exclude_products ?? [];

  // eslint-disable-next-line no-nested-ternary
  const qualifyingCartItems = includedProducts.length
    ? cartItemsWithoutGwp.filter((item) => includedProducts.some((product) => product.id === item.product_id))
    : excludedProducts.length
    ? cartItemsWithoutGwp.filter((item) => !excludedProducts.some((product) => product.id === item.product_id))
    : cartItemsWithoutGwp;

  const totalSpend = qualifyingCartItems.reduce((total, qualifyingItem) => total + qualifyingItem.final_line_price, 0);

  const minimumSpendMet = totalSpend >= minimumSpend;

  if (minimumSpendMet) {
    return {
      isInCart,
      isEligible: true,
      remainingSpend: 0,
    };
  }

  return {
    isInCart,
    isEligible: false,
    remainingSpend: minimumSpend - totalSpend,
  };
};
